import { Action, createReducer, on } from '@ngrx/store';
import * as SettingsActions from '../actions/settings.actions';

export const settingsFeatureKey = 'settings';

export interface State {
  locMinQtyLabel1: String
  locMinQtyLabel2: String
  locTaxNameOne: String
  locTaxNumberOne: String
  locTaxValueOne: Number
  locTaxNameTwo: String
  locTaxNumberTwo: String
  locTaxValueTwo: String | Number
  locEnableAutoBarcodeGen: Number
  locEnableCountToInvoice: Number
  locEnableMasterCategories: Number
  locEnableAutoProdCodeGen: Number
  locEnableMultiMinQty: Number
  locEnablePrinting: Number
  locEnableBrotherPrinting: Number
  usrMinStockAlertEnabled: Number  // Changed from location to user level
  usrMinStockAlertFrequency: String  // Frequency: daily, weekly, never
  customFieldPrintable: Number
  locPrdCustomFieldLabel1: String
  locEnableCustomField1: Number,
  locLockCustomField1: Number,
  locPrdCustomFieldLabel2: String
  locEnableCustomField2: Number,
  locLockCustomField2: Number,
  locUsesAssetModule: Number,
  locUsesSerializedModule: Number,
  locUsesCountingModule: Number,
  locIsMovePrdEnabled: Number,
  locHandheldProductEdit: Number | boolean
}

export const initialState: State = {
  locMinQtyLabel1: null,
  locMinQtyLabel2: null,
  locTaxNameOne: null,
  locTaxNumberOne: null,
  locTaxValueOne:null,
  locTaxNameTwo:null,
  locTaxNumberTwo:null,
  locTaxValueTwo: null,
  locEnableAutoBarcodeGen:0,
  locEnableCountToInvoice:0,
  locEnableMasterCategories:0,
  locEnableAutoProdCodeGen:0,
  locEnableMultiMinQty:0,
  locEnablePrinting:0,
  locEnableBrotherPrinting:0,
  usrMinStockAlertEnabled:0,  // Changed from location to user level
  usrMinStockAlertFrequency: 'never',  // Default: never (opt-in)
  customFieldPrintable: 0,
  locPrdCustomFieldLabel1: null,
  locEnableCustomField1:0,
  locLockCustomField1:0,
  locPrdCustomFieldLabel2: null,
  locEnableCustomField2:0,
  locLockCustomField2:0,
  locUsesAssetModule: 0,
  locUsesSerializedModule: 0,
  locUsesCountingModule: 0,
  locIsMovePrdEnabled: 0,
  locHandheldProductEdit: 0
};

export const reducer = createReducer(
  initialState,

  on(SettingsActions.loadSettings, state => state),
  on(SettingsActions.loadSettingsSuccess, (state, { data }) => ({
    ...state,
    locMinQtyLabel1: data.locMinQtyLabel1,
    locMinQtyLabel2: data.locMinQtyLabel2,
    locTaxNameOne: data.locTaxNameOne,
    locTaxNumberOne: data.locTaxNumberOne,
    locTaxValueOne: data.locTaxValueOne,
    locTaxNameTwo: data.locTaxNameTwo,
    locTaxNumberTwo: data.locTaxNumberTwo,
    locTaxValueTwo: data.locTaxValueTwo,
    locEnableAutoBarcodeGen: data.locEnableAutoBarcodeGen,
    locEnableCountToInvoice: data.locEnableCountToInvoice,
    locEnableMasterCategories: data.locEnableMasterCategories,
    locEnableAutoProdCodeGen: data.locEnableAutoProdCodeGen,
    locEnableMultiMinQty: data.locEnableMultiMinQty,
    locEnablePrinting: data.locEnablePrinting,
    locEnableBrotherPrinting: data.locEnableBrotherPrinting,
    usrMinStockAlertEnabled: data.usrMinStockAlertEnabled,  // Changed from location to user level
    usrMinStockAlertFrequency: data.usrMinStockAlertFrequency || 'never',
    customFieldPrintable: data.customFieldPrintable,
    locEnableCustomField1: data.locEnableCustomField1,
    locLockCustomField1: data.locLockCustomField1,
    locPrdCustomFieldLabel1: data.locPrdCustomFieldLabel1,
    locEnableCustomField2: data.locEnableCustomField2,
    locLockCustomField2: data.locLockCustomField2,
    locPrdCustomFieldLabel2: data.locPrdCustomFieldLabel2,
    locUsesAssetModule: data.locUsesAssetModule,
    locUsesSerializedModule: data.locUsesSerializedModule,
    locUsesCountingModule: data.locUsesCountingModule,
    locIsMovePrdEnabled: data.locIsMovePrdEnabled,
    locHandheldProductEdit: data.locHandheldProductEdit
  })),
  on(SettingsActions.loadSettingssFailure, (state, action) => state),
  on(SettingsActions.submitSettingsSuccess, (state, { location }) => ({
    ...state,
    locMinQtyLabel1: location.locMinQtyLabel1,
    locMinQtyLabel2: location.locMinQtyLabel2,
    locTaxNameOne: location.locTaxNameOne,
    locTaxNumberOne: location.locTaxNumberOne,
    locTaxValueOne: location.locTaxValueOne,
    locTaxNameTwo: location.locTaxNameTwo,
    locTaxNumberTwo: location.locTaxNumberTwo,
    locTaxValueTwo: location.locTaxValueTwo,
    locEnableAutoBarcodeGen: location.locEnableAutoBarcodeGen,
    locEnableCountToInvoice: location.locEnableCountToInvoice,
    locEnableMasterCategories: location.locEnableMasterCategories,
    locEnableAutoProdCodeGen: location.locEnableAutoProdCodeGen,
    locEnableMultiMinQty: location.locEnableMultiMinQty,
    locEnablePrinting: location.locEnablePrinting,
    locEnableBrotherPrinting: location.locEnableBrotherPrinting,
    usrMinStockAlertEnabled: location.usrMinStockAlertEnabled,  // Changed from location to user level
    usrMinStockAlertFrequency: location.usrMinStockAlertFrequency || 'never',
    customFieldPrintable: location.customFieldPrintable,
    locEnableCustomField1: location.locEnableCustomField1,
    locLockCustomField1: location.locLockCustomField1,
    locPrdCustomFieldLabel1: location.locPrdCustomFieldLabel1,
    locEnableCustomField2: location.locEnableCustomField2,
    locLockCustomField2: location.locLockCustomField2,
    locPrdCustomFieldLabel2: location.locPrdCustomFieldLabel2,
    locUsesAssetModule: location.locUsesAssetModule,
    locUsesSerializedModule: location.locUsesSerializedModule,
    locUsesCountingModule: location.locUsesCountingModule,
    locIsMovePrdEnabled: location.locIsMovePrdEnabled,
    locHandheldProductEdit: location.locHandheldProductEdit
  })),

);
